module.exports = __webpack_public_path__ + "img/nlp.ad2bb858.svg";